module.exports = __webpack_public_path__ + "static/img/iron.e137efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/iron.png
// module id = ZAPR
// module chunks = 35